import {SearchKontakteViewQuery, useSearchKontakteView} from "../../client/hooks";
import {useTranslation} from "react-i18next";
import {KontaktaufnahmeAuswertungDownloadRequest, ViewKontaktListe} from "../../api";
import {KontakteViewFilter} from "../../components/kontakte/table/FilterTableKontakteView";
import {useMutation} from "react-query";
import {apiUrl} from "../../config";
import {useGetAccessToken} from "../../client";

export const useKontakteHandling = () => {
    const {t: translation} = useTranslation('kontakte');
    const getAccessToken = useGetAccessToken();

    const searchKontakteView: (aufgabeId: string, query: SearchKontakteViewQuery) => Promise<ViewKontaktListe> = useSearchKontakteView();

    const loadKontakteView = async (aufgabeId: string, params: any, filter: KontakteViewFilter): Promise<ViewKontaktListe> => {
        const search: string | undefined = filter.search?.toLowerCase();
        const filtered: string | undefined = params.filtered ?? undefined;
        const page: number = params.page ?? 0;
        const limit: number = params.limit ?? 25;
        const sort: string | undefined = params.sort ?? undefined;

        return await searchKontakteView(aufgabeId, {
            search: search,
            filtered: filtered,
            page: page,
            limit: limit,
            sort: sort,
        })
    }

    const useKontaktaufnahmeDownload = () =>
        useMutation(async (body: KontaktaufnahmeAuswertungDownloadRequest) => {
            const token = await getAccessToken();
            const response = await fetch(`${apiUrl}/api/v1/kontaktaufnahme/auswertung/download`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                let errorMessage = `Download fehlgeschlagen: ${response.statusText}`;
                try {
                    const errorDetails = await response.text();
                    if (errorDetails) {
                        errorMessage += ` (${errorDetails})`;
                    }
                } catch (e) {
                    // Ignore text parsing error
                }
                throw new Error(errorMessage);
            }

            const blob = await response.blob();

            const disposition = response.headers.get("Content-Disposition");

            const dateAktuell = new Date();
            const aktuelleZeit = `${dateAktuell.getFullYear()}-${String(dateAktuell.getMonth() + 1).padStart(2, '0')}-${String(dateAktuell.getDate()).padStart(2, '0')}_${String(dateAktuell.getHours()).padStart(2, '0')}-${String(dateAktuell.getMinutes()).padStart(2, '0')}-${String(dateAktuell.getSeconds()).padStart(2, '0')}`;
            let filename = `kontaktaufnahme-auswertung_${aktuelleZeit}.pdf`;
            if (body.kontaktaufnahmeIds.length === 1) {
                filename = `kontaktaufnahme-auswertung_${body.kontaktaufnahmeIds[0]}_${aktuelleZeit}.pdf`;
            }
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename="?(.*?)"?$/);
                if (match?.[1]) {
                    filename = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => window.URL.revokeObjectURL(url), 0);
        });

    return {
        translation,
        loadKontakteView,
        useKontaktaufnahmeDownload,
    }
}